import { useQueryClient } from '@tanstack/react-query';
import { useShareComponentEntryMutation, getComponentEntryQueryKey } from '@utils/component-framework';

const useShareIGuideEntryMutation = () => {
  const queryClient = useQueryClient();
  const updateComponentEntry = useShareComponentEntryMutation();
  return entryKey => {
    const entry = queryClient.getQueryData(getComponentEntryQueryKey(entryKey));
    updateComponentEntry.mutate({
      entry,
      message: undefined
    });
  };
};

export { useShareIGuideEntryMutation };
//# sourceMappingURL=mutation.share-entry.js.map
